export var BillingStageType = /*#__PURE__*/ function(BillingStageType) {
    BillingStageType["Scheduled"] = "scheduled";
    BillingStageType["Available"] = "available";
    BillingStageType["Billed"] = "billed";
    return BillingStageType;
}({});
